// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JUJZ","grid":"styles_grid__kcZGw","card":"styles_card__TYPrc"};